<div class="effective-date-container">
    <label class="label">Effective Dates</label>
    <kendo-daterange class="date-range">
        <kendo-dateinput kendoDateRangeStartInput [(value)]="range.start" (valueChange)="onDateChange()">
        </kendo-dateinput>
        <kendo-dateinput kendoDateRangeEndInput [(value)]="range.end" (valueChange)="onDateChange()">
        </kendo-dateinput>
        <kendo-daterange-popup></kendo-daterange-popup>
    </kendo-daterange>
</div>
<div class="k-d-flex content k-p-6">
    <div class="col">
        <div class="key">
            Effective Dates
        </div>
        <div class="value">
            {{ range.start | date:'MM/dd/yyyy' }} -
            {{ range.end | date:'MM/dd/yyyy' }}
        </div>
    </div>
    <div class="col">
        <div class="key">
            Award Id Prefix
        </div>
        <div class="value">{{serviceContractDetails?.awardIDPrefix}}</div>
    </div>
    <div class="col">
        <div class="key">
            Award Id Number
        </div>
        <div class="value">{{serviceContractDetails?.awardIDNumber}}</div>
    </div>
    <div class="col">
        <div class="key">
            Award Id Suffix
        </div>
        <div class="value">{{serviceContractDetails?.awardIDSuffix}}</div>
    </div>
</div>

<kendo-card class=" k-mt-4 grid-width">

    <!-- <kendo-fileselect [showFileList]="false"   (select)="uploadFile($event)" 
        [multiple]="false">
    </kendo-fileselect> -->

    <kendo-grid [kendoGridBinding]="gridData" (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
        (selectionChange)="onGobalWaitListSelectionChange($event)" (save)="saveHandler($event)"
        kendoGridSelectBy="agencyRelatedServiceContractSk" (remove)="removeHandler($event)" (add)="addHandler($event)"
        [(selectedKeys)]="relatedServiceSelection" [selectable]="{ mode: 'multiple', drag: true }" [pageSize]="pageSize"
        [pageable]="true" [skip]="skip" (pageChange)="pageChange($event)">
        <ng-template kendoGridToolbarTemplate>
            <div class="flex">
                <h4 class="grid-header">Related Services Contract Award List</h4>
                <div class="d-flex">
                    <!-- <button kendoGridAddCommand themeColor="primary" fillMode="outline"  [svgIcon]="plusIcon">Add New Line Item</button> -->
                    <button kendoGridExcelCommand class="export-btn" (click)="this.excelexport.save()">Export to
                        Excel</button>
                </div>

            </div>
            <div class="inactivate-wrapper" *ngIf="relatedServiceSelection?.length">
                <div class="selected-items">
                    Selected {{relatedServiceSelection?.length}} item(s)
                </div>
                <button kendoButton themeColor="primary" class="btn" fillMode="solid"
                    (click)="inactiveRelatedService()">Inactivate</button>
            </div>

        </ng-template>

        <kendo-grid-checkbox-column [width]="25" [sticky]="true" [width]="52" headerClass="action-column"
            [class]="{ 'text-center': true }" [resizable]="false" [columnMenu]="false" [showSelectAll]="true"
            title="Checkbox column"></kendo-grid-checkbox-column>


        <kendo-grid-column field="schoolType" title="School Type" [width]="150">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="schoolTypeDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="$any(formGroup.get('schoolType'))">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.schoolType,schoolTypeDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="disciplineId" title="Discipline" [width]="176">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="disciplineDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="$any(formGroup.get('disciplineId'))">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.disciplineId,disciplineDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="languageId
        " title="Language" [width]="150">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="languageDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="$any(formGroup.get('languageId'))">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.languageId,languageDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="borough" title="Borough" [width]="150">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="boroughDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="$any(formGroup.get('borough'))">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.borough,boroughDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="district" title="District" [width]="130">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="districtDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="$any(formGroup.get('district'))">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.district,districtDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="awardedTierId" title="Award Tier" [width]="130">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="awardedTierDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="$any(formGroup.get('awardedTierId'))">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.awardedTierId,awardedTierDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="awardedPrice" title="Awarded Price" format="c" [width]="160" editor="numeric">
            <!-- Editing Template -->
            <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <kendo-numerictextbox [formControl]="$any(formGroup.get('awardedPrice'))"
                    [format]="'c'"></kendo-numerictextbox>
            </ng-template>
        </kendo-grid-column>


        <kendo-grid-column field="orderOfUse" title="Order of Use" format="c" [width]="130" editor="numeric">
        </kendo-grid-column>
        <kendo-grid-column field="dateRange" title="Date Range" [width]="270">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-daterange>

                    <kendo-dateinput kendoDateRangeStartInput
                        [formControl]="$any(formGroup.get('dateRange.start'))"></kendo-dateinput>
                    <kendo-dateinput kendoDateRangeEndInput
                        [formControl]="$any(formGroup.get('dateRange.end'))"></kendo-dateinput>
                </kendo-daterange>
            </ng-template>

            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span>
                    {{ dataItem?.effectiveStartDate | date: 'MM/dd/yyyy' }} -
                    {{ dataItem?.effectiveEndDate | date: 'MM/dd/yyyy' }}
                </span>
            </ng-template>


        </kendo-grid-column>

        <kendo-grid-column field="contactName" title="Contact Name" [width]="260">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-textbox rounded="large" [formControl]="$any(formGroup.get('contactName'))"></kendo-textbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.contactName }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="contactTitle" title="Contact Title" [width]="260">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-textbox rounded="large" [formControl]="$any(formGroup.get('contactTitle'))"
                    [maxlength]="64"></kendo-textbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.contactTitle }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="contactEmail" title="Contact Email" [width]="260">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-textbox rounded="large" [formControl]="$any(formGroup.get('contactEmail'))"></kendo-textbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.contactEmail }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="contactPhone" title="Contact Phone Number" [width]="260">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-maskedtextbox [size]="'medium'" [rounded]="'large'"
                    [formControl]="$any(formGroup.get('contactPhone'))" mask="(000) 000-0000"
                    class="k-textbox"></kendo-maskedtextbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.contactPhone }}
            </ng-template>
        </kendo-grid-column>


        <!-- <kendo-grid-command-column title="Actions" [sticky]="true" [width]="110">
            <ng-template kendoGridCellTemplate let-isNew="isNew">

                <button kendoGridEditCommand [svgIcon]="penIcons" themeColor="secondary" class="edit-btn"
                    fillMode="flat" aria-label="Edit row"></button>
                <button kendoGridSaveCommand themeColor="primary" [svgIcon]="checkIcon" [disabled]="formGroup?.invalid"
                    aria-label="Save row">
                </button>
                <button kendoGridCancelCommand class="cancel-btn" [svgIcon]="xMarkIcons" aria-label="Cancel edit">
                </button>
            </ng-template>
        </kendo-grid-command-column> -->
    </kendo-grid>
</kendo-card>



<app-inactive-related-service-dialogbox [relatedServiceSelection]="relatedServiceSelection"
    *ngIf="inactiveRelatedServiceContract$ | async"
    (close)="closeInactiveRelatedServiceContractDialog()"></app-inactive-related-service-dialogbox>



<kendo-excelexport [data]="relatedServiceExportData" fileName="RelatedService.xlsx" #excelexport>
    <kendo-excelexport-column field="schoolType" title="School Type">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="disciplineId" title="Discipline">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="languageId
    " title="Language">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="borough" title="Borough">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="district" title="District">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="awardedTierId" title="Award Tier">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="awardedPrice" title="Awarded Price">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="orderOfUse" title="Order of Use">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="dateRange" title="Date Range">
    </kendo-excelexport-column>
</kendo-excelexport>